module.exports = __webpack_public_path__ + "img/webase2.6054b102.png";